import { Component, computed, HostListener, inject, input, model, signal } from '@angular/core';
import { AssetTypeTag } from '../../shared/asset-type-tag/asset-type-tag';
import { AssetDetail } from '../../services/asset-service/types';
import { AssetService } from '../../services/asset-service/asset.service';
import { Loader } from '../../shared/loader';
import { AssetDownloadButton } from '../../shared/asset-download-button';
import { AssetTrustBadge } from '../../shared/asset-trust-badge/asset-trust-badge';
import { AssetLaunchButton } from '../../shared/asset-launch-button';
import { AssetAccessType } from '../../shared/asset-access-type/asset-access-type';
import { NeedHelpService } from '../../services/need-help.service';

@Component({
  selector: 'asset-detail-header',
  templateUrl: './asset-detail-header.html',
  styleUrl: './asset-detail-header.scss',
  imports: [
    AssetTypeTag,
    Loader,
    AssetDownloadButton,
    AssetTrustBadge,
    AssetLaunchButton,
    AssetAccessType,
  ],
})
export class AssetDetailHeader {
  assetService = inject(AssetService);
  needHelpService = inject(NeedHelpService);

  asset = input.required<AssetDetail>();
  snackbarVisible = model.required<boolean>();
  requestReason = model.required<string>();
  requestAccessModalOpen = model.required<boolean>();
  assetId = computed(() => {
    return this.asset().asset_id;
  });
  isDownloading = signal(false);

  isBookmarked = computed(() => {
    if (!this.assetService.listAllBookmarks.hasValue()) {
      // NOTE: Just for type-safety. Button is disabled when query has no value yet.
      return false;
    }
    const bookmarkedAssetIds = this.assetService.listAllBookmarks
      .value()
      .items.map(({ asset_id }) => asset_id);

    return bookmarkedAssetIds.findIndex((id) => id === this.assetId()) >= 0;
  });
  handleBookmarkButtonClick = () => {
    if (!this.assetService.listAllBookmarks.hasValue()) {
      // Don't send any request if bookmarked state is unknown
      return;
    }

    if (this.isBookmarked()) {
      this.assetService.deleteBookmark(this.assetId);
    } else {
      this.assetService.addBookmark(this.assetId);
    }
  };
  isBookmarkButtonLoading = computed(() => {
    return (
      !this.assetService.listAllBookmarks.hasValue() ||
      this.assetService.listAllBookmarks.isLoading()
    );
  });

  moreOpen = signal(false);

  downloadCountText = computed(() => {
    const count = this.asset().download_count;
    return `${count} Download${count === 1 ? '' : 's'}`;
  });

  @HostListener('document:click')
  closeAllMenus(): void {
    this.moreOpen.set(false);
  }

  toggleMoreMenu(e: MouseEvent): void {
    e.stopPropagation();
    this.moreOpen.update((v) => !v);
  }

  copyLink(): void {
    this.moreOpen.set(false);
    navigator.clipboard.writeText(window.location.href).catch(() => {});
  }

  reportIssue = (): void => {
    this.moreOpen.set(false);
    this.needHelpService.open();
  };
}
